import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { CookiesProvider } from 'react-cookie';
//import registerServiceWorker from './registerServiceWorker';
import 'url-polyfill';
import objectFitImages from 'object-fit-images';
objectFitImages();

ReactDOM.render(
    <CookiesProvider>
      <App />
    </CookiesProvider>,
    document.getElementById('root')
);

//registerServiceWorker();
